<template>
  <section class="relative pb-0 mb-0">
    <tilted-background :disabled="didUserJustLoginOrSignup">
      <div class="container">
        <div class="pb-2 relative flex z-10 flex-col justify-between m:flex-row pt-6 l:pt-16 l:pb-1 l:mb-6">
          <div class="m:w-7/12 l:w-6/12 pb-8 m:pb-12 m:mr-6">
            <copy-section
              :users-email="usersEmail"
              :is-user-logged-in="isUserLoggedIn"
              :did-user-just-login-or-signup="didUserJustLoginOrSignup"
            />
            <buttons-section
              :invite-code="inviteCode"
              :show-login="!isUserLoggedIn"
              :show-signup="!isUserLoggedIn"
              :show-logout-link="!didUserJustLoginOrSignup"
            />
          </div>
          <connected-image v-if="didUserJustLoginOrSignup" class="m:w-5/12 l:w-6/12 m:pl-1 m:pt-8 l:pt-0 l:pl-4" />
          <book-share-image v-else class="m:w-5/12 l:w-6/12 m:pl-1 m:pt-8 l:pt-0 l:pl-20" />
        </div>
      </div>
    </tilted-background>
  </section>
</template>

<script>
import BookShareImage from "@/pages/organisations/components/book-share-image"
import ButtonsSection from "@/pages/organisations/components/buttons-section"
import CopySection from "@/pages/organisations/components/copy-section"
import ConnectedImage from "@/pages/organisations/components/connected-image"
import TiltedBackground from "@/component-library/tilted-background"
import { mapGetters } from "vuex"
import { getLastPathParam, getSearchParam } from "@/utils/location"

export default {
  name: "HeroSection",
  components: {
    BookShareImage,
    ButtonsSection,
    TiltedBackground,
    CopySection,
    ConnectedImage
  },
  computed: {
    ...mapGetters(["isUserLoggedIn", "usersEmail"]),
    didUserJustLoginOrSignup() {
      return getSearchParam("fromLoginSignup") === "true"
    },
    inviteCode() {
      return getLastPathParam()
    }
  }
}
</script>
